import {GarminBuilder} from "gpx-builder";

const GarminPoint: any = GarminBuilder.MODELS.Point;

/**
 * Garmin track point that also writes the speed as a `<speed>` child of `<trkpt>`.
 *
 * GPX 1.1 dropped that element (1.0 had it), but speed-analysis tools such as
 * GPSAR Pro and KA72 only read Doppler speed from there and ignore the Garmin
 * extension. Strava, Garmin Connect and Google Earth skip it, so one file serves all.
 */
export default class GpxTrackPoint extends GarminPoint {
  readonly speed?: number;

  constructor(latitude: number, longitude: number, options: any = {}) {
    super(latitude, longitude, options);
    this.speed = options.speed;
  }

  toObject(): any {
    const {ele, ...rest} = super.toObject();
    return {
      ...(ele === undefined ? {} : {ele}),
      ...(typeof this.speed === "number" ? {speed: this.speed} : {}),
      ...rest
    };
  }
}
